import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "../Login/Login.js";
import History from "../History.js";
import ExportResults from "../ExportResults.js";
import Automation from "../Automation.js";
import UnitTests from "../UnitTests.js";
import GeneralConfig from "../GeneralConfig.js";
import NotFound from "../NotFound.js";
import RecoverPassword from "../RecoverPassword/RecoverPassword.js";
import Register from "../../Register/Register.js";
import ResetPassword from "../ResetPassword.js";
import ProtectedRoute from "../ProtectedRoute.js";
import AdminDashboard from "../AdminDashboard.js"; // Importe o componente
import CodeAnalysis from "../CodeAnalysis.js"; // Ajuste o caminho se necessário
import Profile from "../Profile.js";
import NewHome from "../../home/NewHome.jsx";
import PrivacyPolicy from "../../home/components/privacyPolicy.jsx"; // Importe a nova página
import PaymentStatus from "../../pages/PaymentStatus.js";
import RenewSubscription from "../../pages/RenewSubscription.js"; // Ajuste o caminho conforme necessário

const AppRoutes = () => {
  return (
    <Routes>
      {/* Redireciona a rota raiz para /home */}
      <Route path="/" element={<Navigate to="/home" replace />} />

      {/* Rotas públicas */}
      <Route path="/login" element={<Login />} />
      <Route path="/recover-password" element={<RecoverPassword />} />
      <Route path="/register" element={<Register />} />
      <Route path="/reset-password/:token/:email" element={<ResetPassword />} />
      <Route path="/home/*" element={<NewHome />} /> {/* Página inicial */}
      <Route path="/privacy-policy" element={<PrivacyPolicy />} /> {/* Política de privacidade */}
      <Route path="/payment-status/:payment_id" element={<PaymentStatus />} />
      <Route path="/renew" element={<RenewSubscription />} />

      {/* Rotas privadas */}
      <Route
        path="/history"
        element={
          <ProtectedRoute>
            <History />
          </ProtectedRoute>
        }
      />
      <Route
        path="/export-results"
        element={
          <ProtectedRoute>
            <ExportResults />
          </ProtectedRoute>
        }
      />
      <Route
        path="/automation"
        element={
          <ProtectedRoute>
            <Automation />
          </ProtectedRoute>
        }
      />
      <Route
        path="/unit-tests"
        element={
          <ProtectedRoute>
            <UnitTests />
          </ProtectedRoute>
        }
      />
      <Route
        path="/general-config"
        element={
          <ProtectedRoute>
            <GeneralConfig />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin-dashboard"
        element={
          <ProtectedRoute allowedRoles={["Administrador"]}>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/code-analysis"
        element={
          <ProtectedRoute>
            <CodeAnalysis />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        }
      />
      {/* Página não encontrada */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
